export const DEFAULT_INPUT_PLACEHOLDER = {
  pt: "Insira um novo item",
  es: "Introduce un nuevo ítem",
  en: "Enter a new item",
};
